<template>
  <div class="video_device">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="account">
      <div class="school">
        <el-input placeholder="名称" v-model="filterText"
                  class="margin-bottom-4" size="small" />
        <the-tree title="门禁组织" keyName="门禁组织名称" class="filter-tree"
                  :filterKey="filterText" :update="treeUpdate" :maxDepth="4"
                  @selected="handleSelected" :options="treeOptions"
        />
      </div>

      <div class="content access_ctrl">
        <!-- region 顶部操作栏 -->
        <div class="top-bar">
          <div>
            <p class="statues">
              设备状态
              <el-select v-model="requestBody.deviceStatus" placeholder="全部"
                         size="small" @change="handleSelect" style="width: 100px;">
                <el-option v-for="item in deviceOptions" :key="item.id"
                           :label="item.label" :value="item.id">
                </el-option>
              </el-select>
            </p>
          </div>
          <input-search class="search" @search="search" placeholder="设备名称/编号" />
        </div>
        <div class="top-bar">
          <div class="left">
            <button-add @click="handleAdd()" v-if="permissionCodes.indexOf('020001001') !== -1"/>
            <button-delete @click="remove(selected)" v-if="permissionCodes.indexOf('020001003') !== -1"/>
            <!--<button-cancel @cancel="toVideoPage" value="视频监控中心" style="margin-left: 10px;"/>-->
          </div>
          <div style="display: flex; justify-content: space-between;">
            <!--<button-upload-->
              <!--:cathUrl="uploadUrl"-->
              <!--:onSuccess="onUploadSuccess"-->
              <!--value="导入"/>-->
            <button-export
              :href="exportUrl"
              download="download.xls"
              v-if="permissionCodes.indexOf('035001008') !== -1"
              value="导出"/>
          </div>
        </div>
        <!-- endregion 顶部操作栏 -->
        <!-- region 表格 -->
        <el-table class="width-full" :data="posDevices"
                  header-row-class-name="app-center-table-header"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"/>
          <el-table-column label="设备名称">
            <template slot-scope="scope">
              <span :title="scope.row.deviceName">{{scope.row.deviceName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备编号">
            <template slot-scope="scope">
              <span :title="scope.row.deviceCode">{{scope.row.deviceCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="通道数">
            <template slot-scope="scope">
              <span :title="scope.row.deviceTypeName">{{scope.row.channelNum || '--'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备厂商">
            <template slot-scope="scope">
              <span :title="scope.row.deviceManufacturerName">{{scope.row.deviceManufacturerName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备类型" width="80">
            <template slot-scope="scope">
              <span :title="scope.row.deviceTypeText">{{scope.row.deviceTypeText}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备型号" width="140">
            <template slot-scope="scope">
              <span :title="scope.row.deviceModelName">{{scope.row.deviceModelName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备用途" width="140">
            <template slot-scope="scope">
              <span :title="scope.row.purpose">{{scope.row.purpose}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备状态" width="80">
            <template slot-scope="scope">
              <div style="background-color: #F56C6C;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;" v-if="scope.row.deviceStatus === '0'"></div>
              <div style="background-color: #67C23A;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;" v-else-if="scope.row.deviceStatus === '1'"></div>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220">
            <template slot-scope="scope">
              <a @click="preview(scope.row)" v-if="scope.row.protocolType !== '大华云睿' && scope.row.protocolType !== '海康云眸'">预览</a>
              <a @click="updateChannel(scope.row)" v-if="scope.row.deviceType === '12'">更新通道</a>
              <a @click="showDetail(scope.row.deviceCode)">修改</a>
              <a @click="remove(scope.row.deviceCode)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <!-- endregion 表格 -->
        <div class="page">
          <el-pagination background layout="total, prev, pager, next, jumper"
                         @current-change="onPageChanged" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog :title="previewDeviceName" :visible.sync="dialogVisible" width="800px">
      <vue-aliplayer-v2
        v-if="dialogVisible"
        style="width: 760px;height: 420px;margin: 0 auto;"
        @ready="handleReady"
        ref="VueAliplayerV2"
        :id="aliplayerId"
        :options="options"
      />
      <!--<videoPlayer class="video-player vjs-custom-skin" ref="videoPlayer" :playsinline="true" :options="playerOptions"/>-->
    </el-dialog>

    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">

            <div class="search-line" style="margin: 10px 0">
              <div class="btn-box">
                {{previewDeviceName}}
              </div>

            </div>
            <div>
              <table-main :selection="false" :tableHead="windowLeftTableHead" :tableData="windowLeftTableData" :total="windowLeftTotal" :pageNum="windowLeftPageNum" :pageSize="windowLeftPageSize"  @changePagination="changeWindowLeftPagination" @previewStream="previewStream" :operationArr="windowLeftOperationArr" />
            </div>
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>

    <div class="DHVideoPlayer"></div>

    <el-dialog title="温馨提示" :visible.sync="dHVideoDialogVisible" width="40%">
      <p style="padding: 20px 0;">此视频需下载并安装播放软件才可播放,安装好后若无法播放,请刷新页面 <a href="https://yq.damaiiot.com/yq/DHPlayerSetup.exe" download="DHPlayerSetup.exe" style="margin-left: 20px;color: #00a0e6;">请点击此处下载</a></p>
      <span slot="footer" class="dialog-footer">
        <!--<el-button @click="dHVideoDialogVisible = false" size="mini">稍后观看</el-button>-->
        <el-button type="primary" @click="play" size="small">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../../api/VideoServices";
import TheTree from "../../../components/common/the-tree";
import {
  nAlert,
  nError,
  nSuccess,
  nTipFunc,
  nWarn
} from "../../../utils/notice";
import InputSearch from "../../../components/common/inputs/input-search";
import ButtonAdd from "../../../components/common/buttons/button-add";
import ButtonDelete from "../../../components/common/buttons/button-delete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import BreadCrumb from "../../../components/common/di-ding/common/bread-crumb";
import { errorHandler } from "../../../utils/errorHandler";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import STree from "../../../components/common/s-tree";
import "video.js/dist/video-js.css";
// import {videoPlayer} from 'vue-video-player'
import "videojs-flash";
import { treeApi } from "../../api/TreeApi";
import "video.js/dist/video-js.css";
import "vue-video-player/src/custom-theme.css";
import "videojs-contrib-hls.js/src/videojs.hlsjs";
import { bus } from "../../../utils/bus";
import TableMain from "../../../components/Table/TableMain";
import "../../../tool/videoPlayer";
import ButtonCancel from "../../../components/Button/ButtonCancel";

var oVideoControl = null;
var initCount = 0;

export default {
  name: "video-device",
  components: {
    ButtonCancel,
    TableMain,
    STree,
    Breadcrumb,
    BreadCrumb,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    InputSearch,
    TheTree
    // videoPlayer,
  },
  data() {
    return {
      deviceOptions: [
        {
          id: "",
          label: "全部"
        },
        {
          id: "0",
          label: "离线"
        },
        {
          id: "1",
          label: "在线"
        }
      ],
      treeOptions: {
        1: ["add"],
        2: ["add", "patch", "delete"],
        3: ["add", "patch", "delete"],
        4: ["patch", "delete"]
      },
      config: {
        breadcrumb: [
          {
            value: "智慧监控",
            name: "video-device"
          },
          {
            value: "设备管理"
          }
        ]
      },
      // region 更新树的方法
      treeUpdate: {
        render: code => {
          return this.$axios
            .get(`${api.getVideoOrganizationByParentCode}/${code || "0"}`, {})
            .then(res => {
              let list = res.data.data;
              list.forEach(tree => {
                tree._label = tree.name;
              });
              return list;
            });
        },
        addNode: node => {
          node.name = node._label;
          return this.$axios
            .post(`${api.addVideoOrganization}`, node)
            .then(res => {
              nSuccess("添加成功");
            });
        },
        removeNode: id => {
          let idStr = id + "";
          return this.$axios
            .post(`${api.deleteVideoOrganizationByCodes}`, [idStr])
            .then(res => {
              nSuccess("删除成功");
            });
        },
        editNode: node => {
          node.name = node._label;
          return this.$axios
            .post(`${api.updateVideoOrganization}`, node)
            .then(res => {
              nSuccess("修改成功");
            });
        }
      },
      // endregion 更新树的方法
      exportUrl: "",
      uploadUrl: "",

      filterText: "",
      posDevices: [],
      total: 0,
      requestBody: {
        pageNum: "1",
        pageSize: "10",
        searchKey: "",
        organizationCode: "",
        deviceStatus: "",
        deviceType: ""
      },
      id: "1",
      treeFromServer: [],
      tree: [],
      selected: "",
      enterpriseCode: "",
      enterpriseHasRoomCode: "",
      enterpriseHasRoomNumber: "",
      organizationCode: "",
      organizationName: "",

      dialogVisible: false,
      previewDeviceName: "",
      previewDeviceCode: "",

      dHVideoDialogVisible: false,
      dHPreviewToken: "",
      dHPreviewDeviceId: 0,

      // 视频播放
      aliplayerId: "",
      playerOptions: {},
      options: {
        source: ""
        // source: 'rtmp://202.69.69.180:443/webcast/bshdlive-pc'
        // source: 'rtmp://vs.damaiiot.com/live/34020000001320000003?auth_key=1589963097-0-0-6c2fda035259eea6afe47f442026c3db'
      },

      windowLeftBox: false,
      windowLeftTableHead: [
        {
          prop: "name",
          label: "通道名称"
        },
        {
          prop: "streamId",
          label: "通道ID"
        },
        {
          isStatus: true,
          prop: "deviceStatus",
          label: "设备状态"
        }
      ],
      windowLeftTableData: [],
      windowLeftTotal: 0,
      windowLeftPageNum: 1,
      windowLeftPageSize: 10,
      windowLeftOperationArr: ["previewStream"]
    };
  },
  created() {
    window.sessionStorage.setItem("noDhVideo", "0");
    this.render();
    this.permissionCodes = bus.global.permissionCodes;
    // this.initPlayer()
    // this.init()
  },
  activated() {
    this.render();
  },
  methods: {
    // 跳转视频监控中心
    toVideoPage() {
      window.open(`https://yq.damaiiot.com/video_page`, "_blank");
    },

    handleReady(e) {
      console.log(`ready`, e);
    },
    /**
     * 多选框选择事件
     */
    handleSelectionChange(selectedIds) {
      console.log(selectedIds);
      let deviceCodeArr = [];
      selectedIds.map(v => {
        deviceCodeArr.push(v.deviceCode);
      });
      this.selected = deviceCodeArr.join(",");
    },

    /**
     * 移除
     */
    remove(codes) {
      if (codes.length === 0) {
        nWarn("请先选择需要删除的设备");
        return;
      }
      this.$confirm("确认删除此设备？").then(
        () => {
          this.$axios
            .post(`${api.deleteVideoDeviceByCodes}`, { codes: codes })
            .then(nTipFunc("删除成功"))
            .catch(() => {
              nError("删除失败");
            })
            .then(this.render);
        },
        () => {
          console.debug("用户取消了删除");
        }
      );
    },

    // 更新通道
    updateChannel(data) {
      this.$axios
        .post(`${api.updateChannel}`, {
          deviceCode: data.deviceCode
        })
        .then(res => {
          nSuccess("更新成功");
          this.render();
        })
        .catch(errorHandler("更新失败"));
    },

    init() {
      oVideoControl.init();
    },
    initPlayer() {
      oVideoControl = new videoPlayer({
        videoClassName: "DHVideoPlayer", //视频id
        width: 800,
        height: 560,
        connectSuccess: function() {
          console.log("初始化成功");
        },
        connectClose: function() {
          oVideoControl = null;
        }
      });
    },
    play() {
      this.dHVideoDialogVisible = false;
      oVideoControl.event.play(
        this.dHPreviewToken,
        this.previewDeviceCode,
        this.dHPreviewDeviceId
      );
    },
    playVideo(token, deviceId) {
      oVideoControl.event.playVideo(token, deviceId);
    },
    getWindowState() {
      oVideoControl.event.getWindowState();
    },

    // 预览
    preview(row) {
      let deviceName = row.deviceName;
      let deviceCode = row.deviceCode;
      let protocolType = row.protocolType;
      this.previewDeviceName = deviceName;
      this.previewDeviceCode = deviceCode;
      if (row.deviceType === "11") {
        // 如果是摄像头设备，直接查询rtmp流
        this.$axios
          .post(`${api.preview}`, { deviceCode: deviceCode })
          .then(res => {
            let data = res.data.data;
            if (data) {
              if (protocolType === "大华云睿") {
                let token = data;
                this.dHPreviewToken = token;
                setTimeout(() => {
                  let noDhVideo = window.sessionStorage.getItem("noDhVideo");
                  if (noDhVideo === "1") {
                    this.dHVideoDialogVisible = true;
                  } else {
                    this.play();
                  }
                }, 2000);
                // this.play(token, deviceCode)
              } else {
                let videoUrl = data.split(",");
                this.options.source = videoUrl[0];
                let timestamp = new Date().getTime();
                this.aliplayerId = `${bus.global.yqCode}${timestamp} `;
                console.log(this.options);
                this.dialogVisible = true;
              }
            } else {
              nError("预览失败");
            }
          })
          .catch(errorHandler("预览失败"));
      } else if (row.deviceType === "12") {
        // 如果是平台，查询通道
        this.getChannel(deviceCode, protocolType);
      }
    },

    // 通道预览
    previewStream(row) {
      this.$axios
        .post(`${api.previewStream}`, {
          streamId: row.streamId,
          deviceCode: row.deviceCode
        })
        .then(res => {
          let data = res.data.data;
          if (data) {
            if (row.protocolType === "大华云睿") {
              let token = data;
              this.dHPreviewToken = token;
              this.dHPreviewDeviceId = parseInt(row.streamId);
              setTimeout(() => {
                let noDhVideo = window.sessionStorage.getItem("noDhVideo");
                if (noDhVideo === "1") {
                  this.dHVideoDialogVisible = true;
                } else {
                  this.play();
                }
              }, 2000);
              // this.play(token, deviceCode)
            } else {
              let videoUrl = data.split(",");
              this.options.source = videoUrl[0];
              let timestamp = new Date().getTime();
              this.aliplayerId = `${bus.global.yqCode}${timestamp} `;
              this.dialogVisible = true;
            }
          } else {
            nError("预览失败");
          }
        })
        .catch(errorHandler("预览失败"));
    },

    changeWindowLeftPagination(data) {
      this.windowLeftPageNum = data[0];
      this.windowLeftPageSize = data[1];
      this.getChannel(this.previewDeviceCode);
    },

    // 查询通道
    getChannel(deviceCode, protocolType) {
      this.$axios
        .post(`${api.getChannel}`, {
          deviceCode: deviceCode
        })
        .then(res => {
          let data = res.data.data;
          data.map(v => {
            v.protocolType = protocolType;
          });
          this.windowLeftBox = true;
          this.windowLeftTotal = data.length;
          this.windowLeftTableData = data;
        })
        .catch(errorHandler("查询通道失败"));
    },

    render() {
      this.renderPosDevices();
    },

    renderPosDevices() {
      this.$axios
        .post(`${api.getVideoDevicePage}`, this.requestBody)
        .then(res => {
          let data = res.data.data;
          // for (let k = 0; k < data.list.length; k++) {
          //   if (data.list[k].deviceStatus === '1') {
          //     data.list[k].deviceStatus = '在线'
          //   } else {
          //     data.list[k].deviceStatus = '离线'
          //   }
          // }
          this.total = data.total;
          data.list.map(v => {
            if (v.deviceType === "11") {
              v.deviceTypeText = "摄像头";
            } else if (v.deviceType === "12") {
              v.deviceTypeText = "平台";
            }
          });
          this.posDevices = data.list;
        })
        .catch(errorHandler("查询失败"));
    },

    onPageChanged(page) {
      this.requestBody.pageNum = page + "";
      this.renderPosDevices();
    },

    search(val) {
      this.requestBody.pageNum = "1";
      this.requestBody.searchKey = val;
      this.renderPosDevices();
    },

    handleSelect(val) {
      this.requestBody.pageNum = "1";
      this.requestBody.deviceStatus = val;
      this.renderPosDevices();
    },

    scenceSelect(val) {
      this.requestBody.pageNum = "1";
      this.requestBody.scence = val;
      this.renderPosDevices();
    },

    deviceTypeSelect(val) {
      this.requestBody.pageNum = "1";
      this.requestBody.deviceType = val;
      this.renderPosDevices();
    },

    handleAdd() {
      if (!this.organizationCode) {
        nAlert("请先选择设备所属组织");
        return;
      }
      window.sessionStorage.setItem(
        "videoOrganizationCode",
        this.organizationCode
      );
      window.sessionStorage.setItem(
        "videoOrganizationName",
        this.organizationName
      );
      this.$router.push({
        name: "video-device-add"
      });
    },

    handleSelected(node) {
      this.requestBody.pageNum = "1";
      this.organizationCode = node.data.code;
      this.organizationName = node.data.name;
      this.requestBody.organizationCode = node.data.code;
      this.renderPosDevices();
    },

    showDetail(code) {
      this.$router.push({
        path: "/video_device_modify/" + code
      });
    },

    onUploadSuccess(data) {
      const e = errorHandler("导入失败")(data);
      if (!(e instanceof Error)) {
        nSuccess("导入成功");
        this.render();
      }
    }
  }
};
</script>

<style scoped>
.account {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}

.school {
  width: 22%;
  float: left;
  padding: 20px 10px 0 0;
  border-right: 1px solid #e6ebf2;
}

.yq_name li {
  width: 100px;
}

.content {
  width: 77%;
  float: left;
  padding-top: 20px;
  margin-left: 1%;
  position: relative;
}

.statues {
  display: inline-block;
  line-height: 32px;
  margin-right: 10px;
}

.select-box select {
  width: 60%;
  height: 24px;
  margin-left: 5px;
  border: 1px solid #d7d7d7;
}

.info ul {
  height: 42px;
  color: #48576a;
  font-weight: 400;
  background-color: #eff1f5;
  line-height: 40px;
  margin-top: 5px;
}

.page {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 20px;
}
.width-full a {
  color: #00a0e6;
}
.width-full a:hover {
  color: #06b3ff;
}
</style>

<style lang="less">
.video_device {
  .top-bar {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    margin: 0 10px 15px 15px;
    .left {
      display: flex;
      flex-direction: row;
      align-items: center;
    }
    .search {
      width: 240px;
    }
    .export {
      width: 80px;
      height: 30px;
      line-height: 30px;
      color: #ffffff;
      border-radius: 5px;
      float: left;
      font-size: 14px;
      color: white;
      margin-right: 2%;
      text-align: center;
      border: 0;
      font-weight: 400;
      color: #48576a;
      border: 1px solid #d7d7d7;
      background-color: #f7f7f7;
      &:hover {
        color: #00a0e6 !important;
        border: 1px solid #00a0e6 !important;
      }
    }
  }
  .el-tree-node.is-current > .el-tree-node__content {
    background-color: #f0f7ff;
  }

  .app-center-table-header th {
    background-color: #eff1f5 !important;
    color: #48576a;
    .cell {
      text-align: center;
    }
  }

  .window-left-box {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 60%;
    z-index: 10;
  }
  .window-left-box .move-enter-active,
  .window-left-box .move-leave-active {
    transition: all 2s linear;
    transform: translate3d(0, 0, 0);
  }
  .window-left-box .move-enter,
  .window-left-box .move-leave {
    transform: translate3d(100%, 0, 0);
  }
  .window-left-main {
    width: 100%;
    height: 100%;
    z-index: 30;
    background: #ffffff;
    padding: 5px 10px;
    overflow: auto;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: 0.4;
    z-index: -1;
    background-color: #000000;
    transition: opacity 0.5s ease;
  }
}
</style>
  
<style lang="less" scoped>
/deep/.el-table .cell {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/VideoServices/VideoDevice/VideoDevice.vue